module.exports = __webpack_public_path__ + "first-20_watermark.jpg?1ac9da20a104a5ae275ac79761a1ce73";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20_watermark.jpg
// module id = 509
// module chunks = 0